import React, { useMemo, useState, useEffect } from "react";
import { Drawer, Box, Typography, IconButton, TextField, Button } from "@mui/material";
import WarningAmberRounded from "@mui/icons-material/WarningAmberRounded";

function SaveTripDrawer({ open, onClose, defaultTripName = "My Trip", imageUrl = "/get.jpg", onCreate, headerHeight = 64 }) {
  const [tripName, setTripName] = useState(defaultTripName);

  useEffect(() => {
    setTripName(defaultTripName || "My Trip");
  }, [defaultTripName]);

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ pointerEvents: 'none' }}
      PaperProps={{
        sx: {
          width: 390,
          top: `${headerHeight}px`,
          height: `calc(100% - ${headerHeight}px)`,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          position: 'fixed',
          right: 0,
          pointerEvents: 'auto',
        },
      }}
      ModalProps={{
        hideBackdrop: true,
        disableAutoFocus: true,
        disableEnforceFocus: true,
        disableRestoreFocus: true,
        disableScrollLock: true,
        BackdropProps: {
          sx: {
            top: `${headerHeight}px`,
            height: `calc(100% - ${headerHeight}px)`,
          },
        },
      }}
    >
      <Box sx={{ position: "relative", height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Close */}
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", top: 8, left: 8 }} aria-label="Close">
          ✕
        </IconButton>

        {/* Content */}
        <Box sx={{ p: 3, pt: 5 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 22, mb: 1 }}>Create your new Trip</Typography>
          <Typography sx={{ color: "#666", fontSize: 13, mb: 2 }}>
            Organize, manage and plan where you're going — no matter where you book.
          </Typography>

          {/* Warning banner */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              background: "#FFF4E5",
              border: "1px solid #FFE3BF",
              color: "#7A4F01",
              borderRadius: 1.5,
              py: 1.25,
              px: 1.5,
              mb: 2,
            }}
          >
            <WarningAmberRounded sx={{ color: "#EF6C00" }} />
            <Typography sx={{ fontWeight: 700, fontSize: 14 }}>Your Trip is not saved yet!</Typography>
          </Box>

          {/* Input row with thumbnail */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                width: 88,
                height: 72,
                borderRadius: 1,
                overflow: "hidden",
                flex: "0 0 auto",
                backgroundColor: "#f5f5f5",
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <TextField
              value={tripName}
              onChange={(e) => setTripName(e.target.value.slice(0, 50))}
              placeholder="Los Angeles Trip"
              variant="outlined"
              size="medium"
              fullWidth
              inputProps={{ maxLength: 50 }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1,
                },
                "& .MuiInputBase-input": { fontWeight: 600, fontSize: 16, color: "#111" },
              }}
            />
          </Box>
          <Typography sx={{ color: "#999", fontSize: 12, mt: 0.5 }}>50 characters maximum</Typography>

          <Button
            onClick={() => onCreate?.(tripName)}
            fullWidth
            variant="contained"
            sx={{
              mt: 2,
              background: "linear-gradient(135deg, #ff690f 0%, #e8381b 100%)",
              color: "#fff",
              borderRadius: 2,
              py: 1.25,
              fontWeight: 700,
              textTransform: "none",
              fontSize: 14,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              "&:hover": { background: "#e65c00" },
            }}
          >
            Create Trip
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}

export default SaveTripDrawer;


